
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.8 8l-1.5-3.4c-.1-.2-.2-.3-.3-.3l-7.7-2.9c-.1-.1-.3-.1-.4 0L2.1 4.3c-.1 0-.3.2-.3.3L.2 8c-.1.2-.1.4 0 .5.1.2.2.3.3.4l1.1.4v5.8c0 .3.2.5.4.6l7.7 2.9h.4l7.7-2.9c.2-.1.4-.3.4-.6V9.3l1.1-.4c.2-.1.3-.2.3-.4.2-.1.2-.3.2-.5zM10 2.6l6 2.3-6 2.3-6-2.3 6-2.3zM2.6 5.7l6.6 2.5-1 2.3-6.6-2.6 1-2.2zm.3 4.1l5.4 2.1h.2c.2 0 .4-.1.5-.4l.4-1v6.6l-6.6-2.5.1-4.8zm14.2 4.9l-6.6 2.5v-6.7l.4 1c.1.2.3.4.5.4h.2L17 9.8l.1 4.9zm-5.3-4.2l-1-2.3 6.6-2.5 1 2.3-6.6 2.5z"}})])
          )
        }
      }
    